import { useState } from "react"

interface CollapsibleSectionProps {
  title: string
  defaultOpen?: boolean
  children: React.ReactNode
}

export default function CollapsibleSection({
  title,
  defaultOpen = true,
  children,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div>
      <h3>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="group relative flex w-full items-center justify-between py-6 text-left cursor-pointer"
          aria-expanded={open}
        >
          <span className="text-gray-900 text-xl font-medium">{title}</span>
          <i
            className={`fa-solid fa-chevron-down text-gray-500 transition-transform duration-200 ${
              open ? "rotate-180" : ""
            }`}
          />
        </button>
      </h3>
      {open && <div className="pb-6">{children}</div>}
    </div>
  )
}
